import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { SelectionState, Modifier, CompositeDecorator, EditorState as EditorState$1, convertFromRaw, RichUtils, convertToRaw, Editor as Editor$1, ContentState, convertFromHTML } from 'draft-js';
import immutable, { Map } from 'immutable';
import { Dropdown, Button, Menu, Modal, Icon } from '@canaveral/components';
import { SketchPicker } from 'react-color';
import uniqueId from 'react-html-id';

var styles = {"Rte_block__p":"rnl-Rte-block--p","Rte_block__alignLeft":"rnl-Rte-block--alignLeft","Rte_block__alignCenter":"rnl-Rte-block--alignCenter","Rte_block__alignRight":"rnl-Rte-block--alignRight","Rte_block__alignJustify":"rnl-Rte-block--alignJustify"};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var PRIMARY_HEX = '#0096ff';
var SECONDARY_HEX = '#88bb41';
var TERTIARY_HEX = '#d6d6d6';
var BLACK_HEX = '#000000';
var WHITE_HEX = '#ffffff'; // Same as $editor-control-color in theme.scss.

var CONTROL_COLOR = WHITE_HEX; // Same as $editor-control-background-color theme.scss.

var CONTROL_BG_COLOR = '#2e2b2a'; // Same as $editor-content-body-color in theme.scss.

var CONTENT_BODY_COLOR = '#686868';

var _colors, _fonts;
var PRIMARY = 'primary';
var SECONDARY = 'secondary';
var TERTIARY = 'tertiary';
var BODY = 'body';
var BLACK = 'black';
var WHITE = 'white';
var defaultTheme = {
  colors: (_colors = {}, _defineProperty(_colors, PRIMARY, PRIMARY_HEX), _defineProperty(_colors, SECONDARY, SECONDARY_HEX), _defineProperty(_colors, TERTIARY, TERTIARY_HEX), _defineProperty(_colors, BODY, CONTENT_BODY_COLOR), _defineProperty(_colors, BLACK, BLACK_HEX), _defineProperty(_colors, WHITE, WHITE_HEX), _colors),
  fieldReplacements: {},
  fonts: (_fonts = {}, _defineProperty(_fonts, PRIMARY, undefined), _defineProperty(_fonts, SECONDARY, undefined), _fonts),
  filesModalComponentClass: null
};

var _React$createContext = React.createContext(defaultTheme),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;
var createTheme = function createTheme(_ref) {
  var _colors2;

  var colors = _ref.colors,
      fieldReplacements = _ref.fieldReplacements,
      filesModalComponentClass = _ref.filesModalComponentClass,
      fonts = _ref.fonts;
  return {
    colors: (_colors2 = {}, _defineProperty(_colors2, PRIMARY, (colors[PRIMARY] || PRIMARY_HEX).toLowerCase()), _defineProperty(_colors2, SECONDARY, (colors[SECONDARY] || SECONDARY_HEX).toLowerCase()), _defineProperty(_colors2, TERTIARY, (colors[TERTIARY] || TERTIARY_HEX).toLowerCase()), _defineProperty(_colors2, BODY, (colors[BODY] || CONTENT_BODY_COLOR).toLowerCase()), _defineProperty(_colors2, BLACK, (colors[BLACK] || BLACK_HEX).toLowerCase()), _defineProperty(_colors2, WHITE, (colors[WHITE] || WHITE_HEX).toLowerCase()), _colors2),
    fieldReplacements: fieldReplacements,
    filesModalComponentClass: filesModalComponentClass,
    fonts: fonts
  };
};

var HEADER_ONE = 'header-one';
var HEADER_TWO = 'header-two';
var HEADER_THREE = 'header-three';
var HEADER_FOUR = 'header-four';
var HEADER_FIVE = 'header-five';
var HEADER_SIX = 'header-six';
var UNORDERED_LIST_ITEM = 'unordered-list-item';
var ORDERED_LIST_ITEM = 'ordered-list-item';
var ATOMIC = 'atomic';
var BLOCKQUOTE = 'blockquote';
var UNSTYLED = 'unstyled';

var ALIGN = 'align';
var ALIGN_LEFT = 'left';
var ALIGN_CENTER = 'center';
var ALIGN_RIGHT = 'right';
var ALIGN_JUSTIFY = 'justify';

/**
 * Defines class names to apply to the given block when it is rendered.
 * @param  {ContentBlock} contentBlock
 * @return {string}
 */

var applyBlockClasses = (function (contentBlock) {
  var type = contentBlock.getType();
  var blockData = contentBlock.getData();
  var align = blockData.get(ALIGN);
  return cx(type === UNSTYLED && styles.Rte_block__p, align && styles["Rte_block__align".concat(align[0].toUpperCase() + align.slice(1))]);
});

var BOLD = 'BOLD';
var ITALIC = 'ITALIC';
var UNDERLINE = 'UNDERLINE';
var STRIKETHROUGH = 'STRIKETHROUGH'; // RTE currently does not support this control. Added to support SM-specific inline styles.

var TEXT_TRANSFORM = 'TEXT_TRANSFORM';
var FONT_SIZE = 'FONT_SIZE';
var FONT_FAMILY = 'FONT_FAMILY'; // RTE currently does not support this control. Added to support SM-specific inline styles.

var FONT_WEIGHT = 'FONT_WEIGHT';
var COLOR = 'COLOR';
var BACKGROUND_COLOR = 'BACKGROUND_COLOR';

/**
 * Transforms inline styles and block metadata to CSS objects that are applied
 * to spans of text.
 * @param  {DraftInlineStyle} draftInlineStyle
 * @param  {ContentBlock}     contentBlock
 * @return {object}
 */

var applyInlineStyles = (function (theme) {
  return function (draftInlineStyle) {
    var inlineStyle = {};
    var fontSize = draftInlineStyle.find(function (value) {
      return value.startsWith(FONT_SIZE);
    });
    var fontFamily = draftInlineStyle.find(function (value) {
      return value.startsWith(FONT_FAMILY);
    });
    var fontWeight = draftInlineStyle.find(function (value) {
      return value.startsWith(FONT_WEIGHT);
    });
    var textTransform = draftInlineStyle.find(function (value) {
      return value.startsWith(TEXT_TRANSFORM);
    });
    var color = draftInlineStyle.find(function (value) {
      return value.startsWith(COLOR);
    });
    var backgroundColor = draftInlineStyle.find(function (value) {
      return value.startsWith(BACKGROUND_COLOR);
    });

    if (fontSize) {
      var _fontSize$split = fontSize.split(':'),
          _fontSize$split2 = _slicedToArray(_fontSize$split, 2),
          size = _fontSize$split2[1];

      var lineHeight = parseInt(size, 10) * 1.5;
      inlineStyle.fontSize = "".concat(size, "px");
      inlineStyle.lineHeight = "".concat(lineHeight, "px");
    }

    if (fontFamily) {
      var _fontFamily$split = fontFamily.split(':'),
          _fontFamily$split2 = _slicedToArray(_fontFamily$split, 2),
          family = _fontFamily$split2[1];

      var font = theme.fonts[family];
      inlineStyle.fontFamily = font && font.value;
    }

    if (fontWeight) {
      var _fontWeight$split = fontWeight.split(':'),
          _fontWeight$split2 = _slicedToArray(_fontWeight$split, 2),
          weight = _fontWeight$split2[1];

      inlineStyle.fontWeight = weight;
    }

    if (textTransform) {
      var _textTransform$split = textTransform.split(':'),
          _textTransform$split2 = _slicedToArray(_textTransform$split, 2),
          transformation = _textTransform$split2[1];

      inlineStyle.textTransform = transformation;
    }

    if (color) {
      var _color$split = color.split(':'),
          _color$split2 = _slicedToArray(_color$split, 2),
          hex = _color$split2[1];

      inlineStyle.color = [PRIMARY, SECONDARY, TERTIARY].includes(hex) ? theme.colors[hex] : hex;
    }

    if (backgroundColor) {
      var _backgroundColor$spli = backgroundColor.split(':'),
          _backgroundColor$spli2 = _slicedToArray(_backgroundColor$spli, 2),
          _hex = _backgroundColor$spli2[1];

      inlineStyle.backgroundColor = [PRIMARY, SECONDARY, TERTIARY].includes(_hex) ? theme.colors[_hex] : _hex;
    }

    return inlineStyle;
  };
});

var FILE = 'FILE';
var LINK = 'LINK';
var FIELD_REPLACEMENT = 'FIELD_REPLACEMENT';
var MUTABLE = 'MUTABLE';
var IMMUTABLE = 'IMMUTABLE';

/* eslint-disable import/prefer-default-export */
/**
 * Static set of utility functions for updating entities based on the edtior's
 * current theme.
 *
 * In each case, these methods accept ContentState objects with relevant parameters
 * and return ContentState objects.
 *
 */

/**
 * Gets list of entity locations in ContentState
 * @param  {ContentBlock} block
 * @return {array}
 */

var getBlockEntityList = function getBlockEntityList(block) {
  var entityList = [];
  var length = block.getLength();
  var entity;

  for (var i = 0; i < length; i += 1) {
    var currentEntity = block.getEntityAt(i);

    if (currentEntity && entity !== currentEntity) {
      entity = currentEntity;
      entityList.push(currentEntity);
    }
  }

  return entityList;
};
/**
 * Gets block entities out of ContentState.
 * @param  {ContentState} contentState
 * @return {array}
 */


var getBlockEntities = function getBlockEntities(contentState) {
  var blockMap = contentState.getBlockMap();
  var blockEntities = [];
  blockMap.forEach(function (block) {
    var entityList = getBlockEntityList(block);
    entityList.forEach(function (entityKey) {
      var blockEntity = {
        entityKey: entityKey,
        blockKey: block.key
      };
      blockEntities.push(blockEntity);
    });
  });
  return blockEntities;
};
/**
 * Gets the start and end values for a range of text.
 * @param  {ContentBlock} block
 * @param  {string} entityKey
 * @return {object}
 */


var getBlockEntityRange = function getBlockEntityRange(block, entityKey) {
  var entityRange;
  block.findEntityRanges(function (value) {
    return value.get('entity') === entityKey;
  }, function (start, end) {
    entityRange = {
      start: start,
      end: end,
      text: block.get('text').slice(start, end)
    };
  });
  return entityRange;
};
/**
 * Updates individual field replacement values.
 * @param  {ContentState} contentState
 * @param  {object} blockEntity
 * @param  {object} fieldReplacements
 * @return {ContentState}
 */


var updateFieldReplacement = function updateFieldReplacement(contentState, blockEntity, fieldReplacements) {
  var entityKey = blockEntity.entityKey,
      blockKey = blockEntity.blockKey;
  var entity = contentState.getEntity(entityKey);
  var entityType = entity.getType();

  if (entityType !== FIELD_REPLACEMENT) {
    return contentState;
  }

  var _entity$getData = entity.getData(),
      key = _entity$getData.key;

  var text = fieldReplacements[key] ? fieldReplacements[key].value : "Field Replacement Key Missing: ".concat(key);
  var block = contentState.getBlockForKey(blockKey);
  var entityRange = getBlockEntityRange(block, entityKey);
  var start = entityRange.start,
      end = entityRange.end;
  var selectionState = SelectionState.createEmpty(blockKey);
  selectionState = selectionState.merge({
    anchorOffset: start,
    focusOffset: end
  });
  var newContentState = Modifier.removeRange(contentState, selectionState, 'forward');
  var newSelectionState = newContentState.getSelectionAfter();
  newContentState = Modifier.insertText(newContentState, newSelectionState, text, block.getInlineStyleAt(start), entityKey);
  return newContentState;
};
/**
 * Updates field replacement values.
 * @param  {ContentState} contentState
 * @param  {object} fieldReplacements
 * @return {ContentState}
 */


var updateFieldReplacements = function updateFieldReplacements(contentState, fieldReplacements) {
  var blockEntities = getBlockEntities(contentState);
  var newContentState = contentState;
  blockEntities.forEach(function (blockEntity) {
    newContentState = updateFieldReplacement(newContentState, blockEntity, fieldReplacements);
  });
  return newContentState;
};

var withProps = (function (Component, extraProps) {
  return function (props) {
    return React.createElement(Component, _extends({}, props, extraProps));
  };
});

var entityStrategy = (function (type) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === type;
    }, callback);
  };
});

var strategy = entityStrategy(FILE);

var styles$1 = {"File":"rnl-EditorState-File"};

var propTypes = {
  contentState: PropTypes.shape({
    getEntity: PropTypes.func.isRequired
  }).isRequired,
  entityKey: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var defaultProps = {
  children: undefined
};

var File = function File(_ref) {
  var contentState = _ref.contentState,
      entityKey = _ref.entityKey,
      children = _ref.children;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      href = _contentState$getEnti.href;

  return React.createElement("a", {
    href: href,
    className: styles$1.File
  }, children);
};

File.propTypes = propTypes;
File.defaultProps = defaultProps;
File.strategy = strategy;

var strategy$1 = entityStrategy(LINK);

var styles$2 = {"Link":"rnl-EditorState-Link"};

var propTypes$1 = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  contentState: PropTypes.shape({
    getEntity: PropTypes.func.isRequired
  }).isRequired,
  entityKey: PropTypes.string.isRequired
};
var defaultProps$1 = {
  children: undefined
};

var Link = function Link(_ref) {
  var contentState = _ref.contentState,
      entityKey = _ref.entityKey,
      children = _ref.children;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      href = _contentState$getEnti.href,
      target = _contentState$getEnti.target;

  var rel = target === '_blank' ? 'noopener noreferrer' : undefined;
  return React.createElement("a", {
    href: href,
    target: target,
    rel: rel,
    className: styles$2.Link
  }, children);
};

Link.propTypes = propTypes$1;
Link.defaultProps = defaultProps$1;
Link.strategy = strategy$1;

var strategy$2 = entityStrategy(FIELD_REPLACEMENT);

var styles$3 = {"FieldReplacement":"rnl-EditorState-FieldReplacement"};

var propTypes$2 = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  contentState: PropTypes.shape({
    getEntity: PropTypes.func.isRequired
  }).isRequired,
  readOnly: PropTypes.bool
};
var defaultProps$2 = {
  children: undefined,
  readOnly: undefined
};

var FieldReplacement = function FieldReplacement(_ref) {
  var readOnly = _ref.readOnly,
      children = _ref.children;
  return readOnly ? children : React.createElement("span", {
    className: styles$3.FieldReplacement
  }, children);
};

FieldReplacement.propTypes = propTypes$2;
FieldReplacement.defaultProps = defaultProps$2;
FieldReplacement.strategy = strategy$2;

var compositeDecorator = (function (props) {
  return new CompositeDecorator([{
    strategy: Link.strategy,
    component: withProps(Link, props)
  }, {
    strategy: File.strategy,
    component: withProps(File, props)
  }, {
    strategy: FieldReplacement.strategy,
    component: withProps(FieldReplacement, props)
  }]);
});

var EditorState = _objectSpread2({}, EditorState$1, {
  createEmpty: function createEmpty(props) {
    return EditorState$1.createEmpty(compositeDecorator(props));
  },
  createWithContent: function createWithContent(contentState, props) {
    return EditorState$1.createWithContent(contentState, compositeDecorator(props));
  }
});

/**
 * Creates an EditorState instance from a raw ContentState.
 * @param  {object} rawContentState
 * @param  {object} props
 * @param  {object} theme
 * @param  {object} theme.fieldReplacements
 * @return {EditorState}
 */

var convertToEditorState = (function (rawContentState, props, _ref) {
  var fieldReplacements = _ref.fieldReplacements;

  if (!rawContentState) {
    return EditorState.createEmpty(props);
  }

  var contentState = convertFromRaw(rawContentState);
  var contentStateWithFieldReplacements = updateFieldReplacements(contentState, fieldReplacements);
  return EditorState.createWithContent(contentStateWithFieldReplacements, props);
});

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", immutable.List.isList),
  map: createImmutableTypeChecker("Map", immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", immutable.Map.isMap);
}

var ImmutablePropTypes_1 = ImmutablePropTypes;

var _Map;
var InlineStyleMap = Map((_Map = {}, _defineProperty(_Map, STRIKETHROUGH, {
  textDecoration: 'line-through'
}), _defineProperty(_Map, UNDERLINE, {
  textDecoration: 'underline'
}), _defineProperty(_Map, BOLD, {
  fontWeight: 'bold'
}), _defineProperty(_Map, ITALIC, {
  fontStyle: 'italic'
}), _Map));

var propTypes$3 = {
  text: PropTypes.string.isRequired,
  styleSet: ImmutablePropTypes_1.orderedSet.isRequired,
  isLast: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired
};
var defaultProps$3 = {};
/*
 * Component modeled after Draft.js' DraftEditorLeaf component
 * https://github.com/facebook/draft-js/blob/v0.10.5/src/component/contents/DraftEditorLeaf.react.js
 *
 * Given each block subset, apply inline styles defined by the editor and theme.
 *
 */

var ContentBlockText = function ContentBlockText(_ref) {
  var text = _ref.text,
      styleSet = _ref.styleSet,
      isLast = _ref.isLast,
      theme = _ref.theme;
  var processedText = text;

  if (text.endsWith('\n') && isLast) {
    processedText += '\n';
  }

  var styleObj = styleSet.reduce(function (map, styleName) {
    var mergedStyles = {};
    var style = InlineStyleMap.get(styleName);

    if (style !== undefined && style.textDecoration && map.textDecoration !== style.textDecoration) {
      mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
    } else if (style !== undefined && style.fontWeight && map.fontWeight !== style.fontWeight) {
      mergedStyles.fontWeight = [map.fontWeight, style.fontWeight].join(' ').trim();
    } else if (style !== undefined && style.fontStyle && map.fontStyle !== style.fontStyle) {
      mergedStyles.fontStyle = [map.fontStyle, style.fontStyle].join(' ').trim();
    }

    return Object.assign(map, style, mergedStyles);
  }, {});
  var newStyles = applyInlineStyles(theme)(styleSet);
  styleObj = Object.assign(styleObj, newStyles);
  return React.createElement(React.Fragment, null, React.createElement("span", {
    style: styleObj
  }, processedText));
};

ContentBlockText.propTypes = propTypes$3;
ContentBlockText.defaultProps = defaultProps$3;

var propTypes$4 = {
  // eslint-disable-next-line react/forbid-prop-types
  contentState: PropTypes.object.isRequired,
  block: PropTypes.shape({
    getKey: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired,
    getInlineStyleAt: PropTypes.func.isRequired,
    getEntityAt: PropTypes.func.isRequired
  }).isRequired,
  decorator: PropTypes.shape({
    getComponentForKey: PropTypes.func,
    getPropsForKey: PropTypes.func
  }),
  tree: ImmutablePropTypes_1.listOf(PropTypes.shape({
    leaves: ImmutablePropTypes_1.listOf(PropTypes.shape({
      start: PropTypes.number,
      end: PropTypes.number
    })),
    decoratorKey: PropTypes.string
  })).isRequired
};
var defaultProps$4 = {
  decorator: undefined
};
/*
 * Component modeled after Draft.js' DraftEditorBlock component
 * https://github.com/facebook/draft-js/blob/v0.10.5/src/component/contents/DraftEditorBlock.react.js
 *
 * Given an EditorState block and a block's inline style tree, we will partition
 * a block by inline styles, create a ContentBlockText component with each block
 * subset, and wrap the subsets in a decorator, i.e., <a>, if necessary.
 *
 */

var ContentBlock = function ContentBlock(_ref) {
  var contentState = _ref.contentState,
      block = _ref.block,
      decorator = _ref.decorator,
      tree = _ref.tree;
  var blockKey = block.getKey();
  var text = block.getText();
  var lastLeafSet = tree.size - 1;
  var processedTrees = tree.map(function (leafSet, ii) {
    var leavesForLeafSet = leafSet.get('leaves');
    var lastLeaf = leavesForLeafSet.size - 1;
    var leaves = leavesForLeafSet.map(function (leaf, jj) {
      var start = leaf.get('start');
      var end = leaf.get('end');
      return React.createElement(Consumer, {
        key: "".concat(blockKey, "-").concat(start, "-consumer")
      }, function (theme) {
        return React.createElement(ContentBlockText, {
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          isLast: ii === lastLeafSet && jj === lastLeaf,
          theme: theme,
          key: "".concat(blockKey, "-").concat(start)
        });
      });
    }).toArray();
    var decoratorKey = leafSet.get('decoratorKey');

    if (decoratorKey == null) {
      return leaves;
    }

    if (!decorator) {
      return leaves;
    }

    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

    if (!DecoratorComponent) {
      return leaves;
    }

    var decoratorProps = decorator.getPropsForKey(decoratorKey);
    var start = leavesForLeafSet.first().get('start');
    var end = leavesForLeafSet.last().get('end');
    var decoratedText = text.slice(start, end);
    var entityKey = block.getEntityAt(leafSet.get('start'));
    var decoratorComponentProps = {
      contentState: contentState,
      decoratedText: decoratedText,
      start: start,
      end: end,
      blockKey: blockKey,
      entityKey: entityKey,
      key: "".concat(blockKey, "-").concat(entityKey, "-").concat(decoratorKey)
    };
    return React.createElement(DecoratorComponent, _extends({}, decoratorProps, decoratorComponentProps), leaves);
  }).toArray();
  return React.createElement(React.Fragment, null, processedTrees);
};

ContentBlock.propTypes = propTypes$4;
ContentBlock.defaultProps = defaultProps$4;

var _Map$1;
var UL_WRAP = React.createElement("ul", null);
var OL_WRAP = React.createElement("ol", null); // Supported block types and their respective rendered elements.
//
// Code block support has purposely been ommitted, see WEB-1038.
//
// See https://github.com/facebook/draft-js/blob/37989027063ccc8279bfdc99a813b857549512a6/src/model/immutable/DefaultDraftBlockRenderMap.js
// for the default render map this map is based on.
//
// See https://draftjs.org/docs/advanced-topics-custom-block-render-map.html#content
// for more information.

var BlockRenderMap = Map((_Map$1 = {}, _defineProperty(_Map$1, HEADER_ONE, {
  element: 'h1'
}), _defineProperty(_Map$1, HEADER_TWO, {
  element: 'h2'
}), _defineProperty(_Map$1, HEADER_THREE, {
  element: 'h3'
}), _defineProperty(_Map$1, HEADER_FOUR, {
  element: 'h4'
}), _defineProperty(_Map$1, HEADER_FIVE, {
  element: 'h5'
}), _defineProperty(_Map$1, HEADER_SIX, {
  element: 'h6'
}), _defineProperty(_Map$1, UNORDERED_LIST_ITEM, {
  element: 'li',
  wrapper: UL_WRAP
}), _defineProperty(_Map$1, ORDERED_LIST_ITEM, {
  element: 'li',
  wrapper: OL_WRAP
}), _defineProperty(_Map$1, ATOMIC, {
  element: 'figure'
}), _defineProperty(_Map$1, BLOCKQUOTE, {
  element: 'blockquote'
}), _defineProperty(_Map$1, UNSTYLED, {
  element: 'div'
}), _Map$1));

/**
 * Modeled after Draft.js' DraftEditorContent component logic
 * https://github.com/facebook/draft-js/blob/v0.10.5/src/component/contents/DraftEditorContents-core.react.js#L137
 *
 * @param {EditorState} Draftjs EditorState
 * @return {array}
 *
 */

var processEditorStateBlocks = (function (editorState) {
  var content = editorState.getCurrentContent();
  var decorator = editorState.getDecorator();
  var blocksAsArray = content.getBlocksAsArray();
  var processedBlocks = blocksAsArray.map(function (block) {
    var key = block.getKey();
    var blockType = block.getType();
    var text = block.getText(); // render <br /> iff the block is a newline

    if (text.trim() === '') {
      return {
        block: React.createElement('br', {
          key: "".concat(key, "-line-break")
        }),
        wrapperTemplate: null
      };
    }

    var configForType = BlockRenderMap.get(blockType) || BlockRenderMap.get('unstyled');
    var wrapperTemplate = configForType.wrapper;
    var element = configForType.element || BlockRenderMap.get('unstyled').element;
    var className = applyBlockClasses(block);
    var childProps = {
      className: className.length ? className : undefined,
      key: "".concat(key, "-").concat(blockType)
    };
    var contentBlockProps = {
      contentState: content,
      block: block,
      decorator: decorator,
      tree: editorState.getBlockTree(key),
      key: "".concat(key, "-content-block")
    };
    var childElement = React.createElement(element, childProps, React.createElement(ContentBlock, contentBlockProps));
    return {
      block: childElement,
      wrapperTemplate: wrapperTemplate,
      key: "".concat(key, "-block")
    };
  });
  var outputBlocks = [];

  for (var ii = 0; ii < processedBlocks.length;) {
    var info = processedBlocks[ii];

    if (info.wrapperTemplate) {
      var blocks = [];

      do {
        blocks.push(processedBlocks[ii].block);
        ii += 1;
      } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);

      var wrapperElement = React.cloneElement(info.wrapperTemplate, {
        key: "".concat(info.key, "-wrap")
      }, blocks);
      outputBlocks.push(wrapperElement);
    } else {
      outputBlocks.push(info.block);
      ii += 1;
    }
  }

  return outputBlocks;
});

var styles$4 = {"Content":"rnl-Content"};

var propTypes$5 = {
  colors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string,
    tertiary: PropTypes.string
  }),
  fieldReplacements: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  fonts: PropTypes.shape({
    primary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    secondary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  }),
  rawContentState: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      type: PropTypes.string,
      depth: PropTypes.number,
      inlineStyleRanges: PropTypes.array,
      entityRanges: PropTypes.array,
      data: PropTypes.object
    })).isRequired,
    entityMap: PropTypes.object.isRequired
  })
};
var defaultProps$5 = {
  colors: {},
  fieldReplacements: {},
  fonts: {},
  rawContentState: undefined
};

var Content = function Content(_ref) {
  var colors = _ref.colors,
      fieldReplacements = _ref.fieldReplacements,
      fonts = _ref.fonts,
      rawContentState = _ref.rawContentState;
  var theme = createTheme({
    colors: colors,
    fieldReplacements: fieldReplacements,
    fonts: fonts
  });
  var editorState = convertToEditorState(rawContentState, {
    readOnly: true
  }, {
    fieldReplacements: fieldReplacements
  });
  var processedEditorStateBlocks = processEditorStateBlocks(editorState);
  return React.createElement(Provider, {
    value: theme
  }, React.createElement("div", {
    className: styles$4.Content
  }, processedEditorStateBlocks));
};

Content.propTypes = propTypes$5;
Content.defaultProps = defaultProps$5;

/**
 * Static set of utility functions for rich text editing, similar to the RichUtils
 * included with Draft.js.
 *
 * In each case, these methods accept EditorState objects with relevant parameters
 * and return immutable data structures or primitives.
 *
 */

/**
 * Gets the `ContentBlock` that contains the start of the current selection.
 * @param  {EditorState} editorState
 * @return {ContentBlock}
 */

var getCurrentBlock = function getCurrentBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  var currentContent = editorState.getCurrentContent();
  return currentContent.getBlockForKey(startKey);
};
/**
 * Gets the ordered map of `ContentBlock` objects that encompass the selected
 * portion of the given editor state.
 * @param  {EditorState} editorState
 * @return {OrderedMap}
 */


var getSelectedBlocksMap = function getSelectedBlocksMap(editorState) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var startKey = selection.getStartKey();
  var endKey = selection.getEndKey();
  var blockMap = contentState.getBlockMap();
  return blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]);
};
/**
 * Gets the entity with a range that either matches or encompasses the current
 * selection or undefined if no entity fulfills those conditions.
 * @param  {EditorState} editorState
 * @return {DraftEntityInstance|undefined}
 */


var getSelectedEntity = function getSelectedEntity(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  var endKey = selection.getEndKey(); // A selection spanning multiple blocks cannot match an entity because
  // entities cannot span multiple blocks.

  if (startKey !== endKey) {
    return undefined;
  }

  var contentState = editorState.getCurrentContent();
  var selectedBlock = contentState.getBlockForKey(startKey);
  var startOffset = selection.getStartOffset();
  var startEntityKey = selectedBlock.getEntityAt(startOffset); // There's no entity here.

  if (!startEntityKey) {
    return undefined;
  } // If the selection's collapsed, the endOffset will be the same as the
  // startOffset so there's no point in checking it.


  if (selection.isCollapsed()) {
    var _entity = contentState.getEntity(startEntityKey);

    return _entity;
  }

  var endOffset = selection.getEndOffset();
  var endEntityKey = selectedBlock.getEntityAt(endOffset - 1); // The endOffset either doesn't have an entity or doesn't have the same entity,
  // so bail.

  if (startEntityKey !== endEntityKey) {
    return undefined;
  }

  var entity = contentState.getEntity(endEntityKey);
  return entity;
};
/**
 * Gets the entity of the given type with a range that either matches or
 * encompasses the current selection or undefined if no entity fulfills those
 * conditions.
 * @param  {EditorState} editorState
 * @param  {string} type
 * @return {DraftEntityInstance|undefined}
 */

var getSelectedEntityWithType = function getSelectedEntityWithType(editorState, type) {
  var entity = getSelectedEntity(editorState);

  if (!entity) {
    return undefined;
  }

  var selectedEntityType = entity.get('type');

  if (type !== selectedEntityType) {
    return undefined;
  }

  return entity;
};
/**
 * Returns the value for the given key of the entity of the given type with a
 * range that either matches or encompasses the current selection or undefined
 * if no entity fulfills those conditions.
 * @param  {EditorState} editorState
 * @param  {string} key
 * @param  {string} type
 * @return {string}
 */

var getSelectedEntityData = function getSelectedEntityData(editorState, key, type) {
  var entity = getSelectedEntityWithType(editorState, type);

  if (!entity) {
    return undefined;
  }

  var data = entity.getData();
  var value = data[key];
  return value;
};
/**
 * Returns the `href` property of the link entity with a range that either matches
 * or encompasses the current selection or an empty string if no link entity
 * fulfills those conditions.
 * @param  {EditorState} editorState
 * @return {string}
 */

var getSelectedLinkHref = function getSelectedLinkHref(editorState) {
  var href = getSelectedEntityData(editorState, 'href', LINK);
  return href;
};
/**
 * Returns the `target` property of the link entity with a range that either matches
 * or encompasses the current selection or undefined if no link entity
 * fulfills those conditions.
 * @param  {EditorState} editorState
 * @return {string|undefined}
 */

var getSelectedLinkTarget = function getSelectedLinkTarget(editorState) {
  var target = getSelectedEntityData(editorState, 'target', LINK);
  return target;
};
/**
 * Gets the variable inline style value associated with the given key for the
 * "current" inline style of the given editorState.
 * @example
 * // returns 14 when the current inline style OrderedSet has FONT_SIZE:14.
 * ContentBlockUtils.getCurrentVariableInlineStyle(editorState, 'FONT_SIZE');
 * @param  {EditorState} editorState
 * @param  {string} key
 * @return {string|undefined}
 */

var getCurrentVariableInlineStyle = function getCurrentVariableInlineStyle(editorState, key) {
  var currentInlineStyle = editorState.getCurrentInlineStyle();
  var style = currentInlineStyle.find(function (value) {
    return value.startsWith(key);
  });
  return style ? style.split(':')[1] : undefined;
};
/**
 * Gets the `ContentBlock` type for the block containing the current selection.
 * If the current selection spans more than one block and one or more of the
 * selected blocks's types are not the same, returns the unstyled type. Otherwise
 * returns the first block's type.
 * @param  {EditorState} editorState
 * @return {string}
 */

var getCurrentBlocksType = function getCurrentBlocksType(editorState) {
  var selectedBlocksMap = getSelectedBlocksMap(editorState);
  var selectionStartBlock = selectedBlocksMap.first();
  var selectionStartBlockType = selectionStartBlock.getType();
  var multipleBlockTypesSelected = selectedBlocksMap.some(function (contentBlock) {
    return contentBlock.getType() !== selectionStartBlockType;
  });
  return multipleBlockTypesSelected ? UNSTYLED : selectionStartBlockType;
};
/**
 * Gets the value associated with the given key in the current block's metadata.
 * @param  {EditorState} editorState
 * @return {string}
 */

var getCurrentBlockData = function getCurrentBlockData(editorState, key) {
  var contentBlock = getCurrentBlock(editorState);
  var blockData = contentBlock.getData();
  return blockData.get(key);
};
/**
 * Gets the selected text.
 * @param  {EditorState}
 * @return {string}
 */

var getSelectedText = function getSelectedText(editorState) {
  var selection = editorState.getSelection();

  if (selection.isCollapsed()) {
    return '';
  }

  var selectedBlocksMap = getSelectedBlocksMap(editorState);
  var startOffset = selection.getStartOffset();
  var endOffset = selection.getEndOffset();
  var startBlock = selectedBlocksMap.first();
  var startBlockText = startBlock.getText();

  if (selectedBlocksMap.size === 1) {
    return startBlockText.slice(startOffset, endOffset);
  }

  var endBlock = selectedBlocksMap.last();
  var endBlockText = endBlock.getText();

  if (selectedBlocksMap.size === 2) {
    return "".concat(startBlockText.slice(startOffset), " ").concat(endBlockText.slice(0, endOffset));
  }

  var restOfBlocks = selectedBlocksMap.rest().butLast();
  var restOfText = restOfBlocks.reduce(function (arr, block) {
    arr.push(block.getText());
    return arr;
  }, []);
  return [startBlockText.slice(startOffset)].concat(_toConsumableArray(restOfText), [endBlockText.slice(0, endOffset)]).join('\n');
};

/**
 * Static set of utility functions for rich text editing, similar to the RichUtils
 * included with Draft.js.
 *
 * In each case, these methods accept EditorState objects with relevant parameters
 * and return EditorState objects.
 *
 */

/**
 * Update the block data for all selected blocks and pushes the new ContentState
 * onto the EditorState as the new currentContent.
 * @param {EditorState}  editorState
 * @param {string}       key
 * @param {string}       value
 * @return {EditorState}
 */

var mergeBlockData = function mergeBlockData(editorState, key, value) {
  var currentContent = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var blockData = Map(_defineProperty({}, key, value));
  var contentState = Modifier.mergeBlockData(currentContent, selection, blockData);
  var newEditorState = EditorState$1.push(editorState, contentState, 'change-block-data');
  return EditorState$1.forceSelection(newEditorState, selection);
};
/**
 * Builds a variable inline style of the form style:value from the specified
 * style value pair and applies it to the entire selected range after removing
 * any old inline styles that start with the specified style from the selected
 * range. Then pushes the new ContentState onto the EditorState as the new
 * currentContent.
 * @example
 * // sets FONT_SIZE:14 on the selected range and removes any old inline styles
 * // that start with FONT_SIZE, like FONT_SIZE:12.
 * CanaveralUtils.applyVariableInlineStyle(editorState, 'FONT_SIZE', '14');
 * @param  {EditorState} editorState
 * @param  {string}      style
 * @param  {string}      value
 * @return {EditorState}
 */

var applyVariableInlineStyle = function applyVariableInlineStyle(editorState, style, value) {
  var currentStyle = editorState.getCurrentInlineStyle();
  var selection = editorState.getSelection();
  var previousStyle = currentStyle.find(function (v) {
    return v.startsWith(style);
  });
  var nextStyle = "".concat(style, ":").concat(value); // If the selection is collapsed, remove the old style and set the result
  // as the new inline style override. This will then be used as the inline
  // style for the next character to be inserted.

  if (selection.isCollapsed()) {
    var inlineStyle = currentStyle.remove(previousStyle).add(nextStyle);
    return EditorState$1.setInlineStyleOverride(editorState, inlineStyle);
  }

  var currentContent = editorState.getCurrentContent();
  var updatedContent = previousStyle ? Modifier.removeInlineStyle(currentContent, selection, previousStyle) : currentContent;
  var contentState = Modifier.applyInlineStyle(updatedContent, selection, nextStyle);
  var newEditorState = EditorState$1.push(editorState, contentState, 'change-inline-style');
  return EditorState$1.forceSelection(newEditorState, selection);
};
/**
 * Creates an entity around the current selection or does nothing if no text
 * is selected.
 * @param  {EditorState} editorState
 * @param  {string} type
 * @param  {object} props
 * @return {EditorState}
 */

var createMutableEntity = function createMutableEntity(editorState, type, _ref) {
  var text = _ref.text,
      props = _objectWithoutProperties(_ref, ["text"]);

  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey(); // Entities spanning multiple blocks are not supported.

  if (anchorKey !== focusKey) {
    return EditorState$1.forceSelection(editorState, selection);
  }

  var anchorOffset = selection.getAnchorOffset();
  var focusOffset = selection.getFocusOffset();
  var isBackward = selection.getIsBackward();
  var selectedText = getSelectedText(editorState);
  var textLengthDifference = text.length - selectedText.length;
  var contentStateWithText = Modifier.replaceText(contentState, selection, text);
  var selectionState = SelectionState.createEmpty(anchorKey);
  var updatedSelection = selectionState.merge({
    focusKey: focusKey,
    isBackward: isBackward,
    anchorOffset: isBackward ? anchorOffset + textLengthDifference : anchorOffset,
    focusOffset: isBackward ? focusOffset : focusOffset + textLengthDifference
  });
  var contentStateWithEntity = contentStateWithText.createEntity(type, MUTABLE, props);
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var newEditorState = EditorState$1.push(editorState, contentStateWithEntity, 'apply-entity');
  var newEditorStateWithLink = RichUtils.toggleLink(newEditorState, updatedSelection, entityKey);
  return EditorState$1.forceSelection(newEditorStateWithLink, updatedSelection);
};
/**
 * Creates a link around the current selection or does nothing if no text
 * is selected.
 * @param  {EditorState} editorState
 * @param  {object} props
 * @param  {string} props.href
 * @param  {string} props.target
 * @param  {string} props.text
 * @return {EditorState}
 */

var createLink = function createLink(editorState, _ref2) {
  var href = _ref2.href,
      target = _ref2.target,
      text = _ref2.text;
  var newEditorState = createMutableEntity(editorState, LINK, {
    href: href,
    target: target,
    text: text
  });
  return newEditorState;
};
/**
 * Creates a link to a file around the current selection or does nothing if no text
 * is selected.
 * @param  {EditorState} editorState
 * @param  {object} props
 * @param  {string} props.href
 * @param  {string} props.text
 * @return {EditorState}
 */

var createFileLink = function createFileLink(editorState, _ref3) {
  var href = _ref3.href,
      text = _ref3.text;
  var newEditorState = createMutableEntity(editorState, FILE, {
    href: href,
    text: text
  });
  return newEditorState;
};
/**
 * Removes links from the current selection or does nothing if no text is selected.
 * @param  {EditorState} editorState
 * @return {EditorState}
 */

var removeLink = function removeLink(editorState) {
  var selection = editorState.getSelection();

  if (selection.isCollapsed()) {
    return EditorState$1.forceSelection(editorState, selection);
  }

  var editorStateWithoutLink = RichUtils.toggleLink(editorState, selection, null);
  return EditorState$1.forceSelection(editorStateWithoutLink, selection);
};
/**
 * Inserts a field replacement entity at the current position of the cursor
 * @param  {EditorState} editorState
 * @param  {object} entity
 * @return {EditorState}
 */

var createFieldReplacement = function createFieldReplacement(editorState, _ref4) {
  var key = _ref4.key,
      value = _ref4.value;
  var contentState = editorState.getCurrentContent();
  var contentStateWithEntity = contentState.createEntity(FIELD_REPLACEMENT, IMMUTABLE, {
    key: key
  });
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var currentSelection = editorState.getSelection();
  var currentInlineStyle = editorState.getCurrentInlineStyle();
  var contentStateWithField = Modifier.replaceText(contentStateWithEntity, currentSelection, value, currentInlineStyle, entityKey);
  var newEditorState = EditorState$1.push(editorState, contentStateWithField, 'apply-entity');
  return newEditorState;
};

var blockDataControl = (function (Component, key) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
        return function () {
          var _this$props = _this.props,
              onChange = _this$props.onChange,
              editorState = _this$props.editorState;
          var newEditorState = mergeBlockData(editorState, key, value);
          onChange(newEditorState);
        };
      });

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var value = getCurrentBlockData(editorState, key);
        return React.createElement(Component, _extends({}, this.props, {
          value: value,
          onChange: this.onChange
        }));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", {
    // eslint-disable-next-line react/forbid-prop-types
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }), _defineProperty(_class, "defaultProps", {}), _temp;
});

var blockTypeControl = (function (Component, type) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onChange", function (newType) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            editorState = _this$props.editorState;
        var blockType = type || newType;
        var newEditorState = RichUtils.toggleBlockType(editorState, blockType);
        onChange(newEditorState);
      });

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var currentType = getCurrentBlocksType(editorState);
        return React.createElement(Component, _extends({}, this.props, {
          value: currentType,
          onChange: this.onChange,
          active: type === currentType
        }));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", {
    // eslint-disable-next-line react/forbid-prop-types
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }), _defineProperty(_class, "defaultProps", {}), _temp;
});

var contrastYIQ = (function (currColor) {
  var color = currColor.slice(1);
  var r = parseInt(color.substr(0, 2), 16);
  var g = parseInt(color.substr(2, 2), 16);
  var b = parseInt(color.substr(4, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000; // Black contrast color is the same as $editor-control-background-color in
  // theme.scss

  return yiq >= 150 ? CONTROL_BG_COLOR : CONTROL_COLOR;
});

var toggleableInlineStyleControl = (function (Component, style) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onChange", function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            editorState = _this$props.editorState;
        var newEditorState = RichUtils.toggleInlineStyle(editorState, style);
        onChange(newEditorState);
      });

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var currentStyle = editorState.getCurrentInlineStyle();
        return React.createElement(Component, _extends({}, this.props, {
          onChange: this.onChange,
          active: currentStyle.has(style)
        }));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", {
    // eslint-disable-next-line react/forbid-prop-types
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }), _defineProperty(_class, "defaultProps", {}), _temp;
});

var variableInlineColorControl = (function (Component, style) {
  var _PropTypes$shape;

  var VariableInlineStyleControl =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(VariableInlineStyleControl, _React$Component);

    function VariableInlineStyleControl() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, VariableInlineStyleControl);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VariableInlineStyleControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            editorState = _this$props.editorState;
        var newEditorState = applyVariableInlineStyle(editorState, style, _this.colorKeyFromHex(value));
        onChange(newEditorState);
      });

      _defineProperty(_assertThisInitialized(_this), "colorKeyFromHex", function (hex) {
        var _colors$PRIMARY$color;

        var colors = _this.props.colors;
        var key = (_colors$PRIMARY$color = {}, _defineProperty(_colors$PRIMARY$color, colors[PRIMARY], PRIMARY), _defineProperty(_colors$PRIMARY$color, colors[SECONDARY], SECONDARY), _defineProperty(_colors$PRIMARY$color, colors[TERTIARY], TERTIARY), _colors$PRIMARY$color)[hex];
        return key || hex;
      });

      _defineProperty(_assertThisInitialized(_this), "colorHexFromKey", function (key) {
        var _PRIMARY$SECONDARY$TE;

        var colors = _this.props.colors;
        var hex = (_PRIMARY$SECONDARY$TE = {}, _defineProperty(_PRIMARY$SECONDARY$TE, PRIMARY, colors[PRIMARY]), _defineProperty(_PRIMARY$SECONDARY$TE, SECONDARY, colors[SECONDARY]), _defineProperty(_PRIMARY$SECONDARY$TE, TERTIARY, colors[TERTIARY]), _PRIMARY$SECONDARY$TE)[key];
        return hex || key;
      });

      return _this;
    }

    _createClass(VariableInlineStyleControl, [{
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var inlineValue = getCurrentVariableInlineStyle(editorState, style);
        var value = this.colorHexFromKey(inlineValue);
        return React.createElement(Component, _extends({}, this.props, {
          value: value,
          onChange: this.onChange
        }));
      }
    }]);

    return VariableInlineStyleControl;
  }(React.Component);

  _defineProperty(VariableInlineStyleControl, "propTypes", {
    colors: PropTypes.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, PRIMARY, PropTypes.string.isRequired), _defineProperty(_PropTypes$shape, SECONDARY, PropTypes.string.isRequired), _defineProperty(_PropTypes$shape, TERTIARY, PropTypes.string.isRequired), _PropTypes$shape)),
    // eslint-disable-next-line react/forbid-prop-types
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  });

  _defineProperty(VariableInlineStyleControl, "defaultProps", {
    colors: {}
  });

  return function (props) {
    return React.createElement(Consumer, null, function (_ref) {
      var colors = _ref.colors;
      return React.createElement(VariableInlineStyleControl, _extends({}, props, {
        colors: colors
      }));
    });
  };
});

var variableInlineStyleControl = (function (Component, style) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            editorState = _this$props.editorState;
        var newEditorState = applyVariableInlineStyle(editorState, style, value);
        onChange(newEditorState);
      });

      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var value = getCurrentVariableInlineStyle(editorState, style);
        var blockType = getCurrentBlocksType(editorState);
        return React.createElement(Component, _extends({}, this.props, {
          value: value,
          blockType: blockType,
          onChange: this.onChange
        }));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", {
    // eslint-disable-next-line react/forbid-prop-types
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }), _defineProperty(_class, "defaultProps", {}), _temp;
});

/*!
 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var icons = {
  'align-center': {
    width: 448,
    height: 512,
    path: 'M352 44v40c0 8.837-7.163 16-16 16H112c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h224c8.837 0 16 7.163 16 16zM16 228h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm320-200H112c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h224c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z'
  },
  'align-justify': {
    width: 448,
    height: 512,
    path: 'M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm16 144h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0-128h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
  },
  'align-left': {
    width: 448,
    height: 512,
    path: 'M288 44v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16zM0 172v40c0 8.837 7.163 16 16 16h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16zm16 312h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm256-200H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z'
  },
  'align-right': {
    width: 448,
    height: 512,
    path: 'M160 84V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H176c-8.837 0-16-7.163-16-16zM16 228h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm160-128h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H176c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
  },
  amazon: {
    width: 448,
    height: 512,
    path: 'M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z'
  },
  ambulance: {
    width: 640,
    height: 512,
    path: 'M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z'
  },
  android: {
    width: 576,
    height: 512,
    path: 'M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55'
  },
  apple: {
    width: 384,
    height: 512,
    path: 'M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z'
  },
  'asl-interpreting': {
    width: 640,
    height: 512,
    path: 'M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z'
  },
  'assistive-listening-systems': {
    width: 512,
    height: 512,
    path: 'M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z'
  },
  'arrow-down': {
    width: 448,
    height: 512,
    path: 'M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z'
  },
  'arrow-up': {
    width: 448,
    height: 512,
    path: 'M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z'
  },
  automobile: {
    width: 480,
    height: 512,
    path: 'M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z'
  },
  bars: {
    width: 448,
    height: 512,
    path: 'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
  },
  bicycle: {
    width: 640,
    height: 512,
    path: 'M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z'
  },
  blind: {
    width: 384,
    height: 512,
    path: 'M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z'
  },
  bluetooth: {
    width: 448,
    height: 512,
    path: 'M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z'
  },
  bold: {
    width: 384,
    height: 512,
    path: 'M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z'
  },
  braille: {
    width: 640,
    height: 512,
    path: 'M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z'
  },
  bus: {
    width: 512,
    height: 512,
    path: 'M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z'
  },
  'caret-down': {
    width: 320,
    height: 512,
    path: 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
  },
  'cc-amex': {
    width: 572,
    height: 512,
    path: 'M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z'
  },
  'cc-diners-club': {
    width: 576,
    height: 512,
    path: 'M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z'
  },
  'cc-discover': {
    width: 576,
    height: 512,
    path: 'M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z'
  },
  'cc-jcb': {
    width: 576,
    height: 512,
    path: 'M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z'
  },
  'cc-mastercard': {
    width: 576,
    height: 512,
    path: 'M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z'
  },
  'cc-paypal': {
    width: 576,
    height: 512,
    path: 'M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z'
  },
  'cc-stripe': {
    width: 576,
    height: 512,
    path: 'M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z'
  },
  'cc-visa': {
    width: 576,
    height: 512,
    path: 'M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z'
  },
  'check-square': {
    width: 448,
    height: 512,
    path: 'M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z'
  },
  circle: {
    width: 512,
    height: 512,
    path: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z'
  },
  'credit-card': {
    width: 576,
    height: 512,
    path: 'M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z'
  },
  deaf: {
    width: 512,
    height: 512,
    path: 'M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z'
  },
  'dot-circle': {
    width: 512,
    height: 512,
    path: 'M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z'
  },
  'exchange': {
    width: 512,
    height: 512,
    path: 'M0 168v-16c0-13.255 10.745-24 24-24h381.97l-30.467-27.728c-9.815-9.289-10.03-24.846-.474-34.402l10.84-10.84c9.373-9.373 24.568-9.373 33.941 0l82.817 82.343c12.497 12.497 12.497 32.758 0 45.255l-82.817 82.343c-9.373 9.373-24.569 9.373-33.941 0l-10.84-10.84c-9.556-9.556-9.341-25.114.474-34.402L405.97 192H24c-13.255 0-24-10.745-24-24zm488 152H106.03l30.467-27.728c9.815-9.289 10.03-24.846.474-34.402l-10.84-10.84c-9.373-9.373-24.568-9.373-33.941 0L9.373 329.373c-12.497 12.497-12.497 32.758 0 45.255l82.817 82.343c9.373 9.373 24.569 9.373 33.941 0l10.84-10.84c9.556-9.556 9.341-25.113-.474-34.402L106.03 384H488c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z'
  },
  'external-link': {
    width: 512,
    height: 512,
    path: 'M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z'
  },
  'eye-dropper': {
    width: 512,
    height: 512,
    path: 'M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z'
  },
  'fighter-jet': {
    width: 640,
    height: 512,
    path: 'M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z'
  },
  flickr: {
    width: 448,
    height: 512,
    path: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z'
  },
  font: {
    width: 448,
    height: 512,
    path: 'M152 416h-24.013l26.586-80.782H292.8L319.386 416H296c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h136c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-26.739L275.495 42.746A16 16 0 0 0 260.382 32h-72.766a16 16 0 0 0-15.113 10.746L42.739 416H16c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h136c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16zm64.353-271.778c4.348-15.216 6.61-28.156 7.586-34.644.839 6.521 2.939 19.476 7.727 34.706l41.335 124.006h-98.619l41.971-124.068z'
  },
  'google-wallet': {
    width: 448,
    height: 512,
    path: 'M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z'
  },
  'hand-down': {
    width: 448,
    height: 512,
    path: 'M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z'
  },
  'hand-left': {
    width: 512,
    height: 512,
    path: 'M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z'
  },
  'hand-lizard': {
    width: 576,
    height: 512,
    path: 'M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z'
  },
  'hand-paper': {
    width: 448,
    height: 512,
    path: 'M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z'
  },
  'hand-peace': {
    width: 448,
    height: 512,
    path: 'M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z'
  },
  'hand-pointer': {
    width: 448,
    height: 512,
    path: 'M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z'
  },
  'hand-right': {
    width: 512,
    height: 512,
    path: 'M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z'
  },
  'hand-rock': {
    width: 512,
    height: 512,
    path: 'M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z'
  },
  'hand-scissors': {
    width: 512,
    height: 512,
    path: 'M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z'
  },
  'hand-spock': {
    width: 512,
    height: 512,
    path: 'M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z'
  },
  'hand-stop': {
    width: 448,
    height: 512,
    path: 'M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z'
  },
  'hand-up': {
    width: 448,
    height: 512,
    path: 'M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z'
  },
  heading: {
    width: 512,
    height: 512,
    path: 'M496 80V48c0-8.837-7.163-16-16-16H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.621v128H154.379V96H192c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.275v320H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.621V288H357.62v128H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.275V96H480c8.837 0 16-7.163 16-16z'
  },
  italic: {
    width: 320,
    height: 512,
    path: 'M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z'
  },
  images: {
    width: 576,
    height: 512,
    path: 'M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z'
  },
  link: {
    width: 512,
    height: 512,
    path: 'M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z'
  },
  'list-ol': {
    width: 512,
    height: 512,
    path: 'M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
  },
  'list-ul': {
    width: 512,
    height: 512,
    path: 'M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'
  },
  'low-vision': {
    width: 576,
    height: 512,
    path: 'M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z'
  },
  'minus-square': {
    width: 448,
    height: 512,
    path: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z'
  },
  motorcycle: {
    width: 640,
    height: 512,
    path: 'M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z'
  },
  palette: {
    width: 512,
    height: 512,
    path: 'M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
  },
  paperclip: {
    width: 448,
    height: 512,
    path: 'M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z'
  },
  paragraph: {
    width: 448,
    height: 512,
    path: 'M408 32H177.531C88.948 32 16.045 103.335 16 191.918 15.956 280.321 87.607 352 176 352v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h32v344c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h40c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24z'
  },
  pencil: {
    width: 512,
    height: 512,
    path: 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z'
  },
  phone: {
    width: 512,
    height: 512,
    path: 'M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z'
  },
  plane: {
    width: 576,
    height: 512,
    path: 'M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z'
  },
  'plus-square': {
    width: 448,
    height: 512,
    path: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z'
  },
  'question-circle-o': {
    width: 512,
    height: 512,
    path: 'M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z'
  },
  'question-circle-solid': {
    width: 512,
    height: 512,
    path: 'M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z'
  },
  'quote-left': {
    width: 512,
    height: 512,
    path: 'M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z'
  },
  redo: {
    width: 512.333,
    height: 512,
    path: 'M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z'
  },
  rocket: {
    width: 512,
    height: 512,
    path: 'M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z'
  },
  save: {
    width: 448,
    height: 512,
    path: 'M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z'
  },
  'fa-search': {
    width: 512,
    height: 512,
    path: 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z'
  },
  'search-minus': {
    width: 512,
    height: 512,
    path: 'M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z'
  },
  'search-plus': {
    width: 512,
    height: 512,
    path: 'M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z'
  },
  ship: {
    width: 640,
    height: 512,
    path: 'M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z'
  },
  'sign-language': {
    width: 448,
    height: 512,
    path: 'M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z'
  },
  slideshare: {
    width: 512,
    height: 512,
    path: 'M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z'
  },
  'space-shuttle': {
    width: 640,
    height: 512,
    path: 'M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z'
  },
  spinner: {
    width: 512,
    height: 512,
    path: 'M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z'
  },
  square: {
    width: 448,
    height: 512,
    path: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z'
  },
  strikethrough: {
    width: 512,
    height: 512,
    path: 'M496 288H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16zm-214.666 16c27.258 12.937 46.524 28.683 46.524 56.243 0 33.108-28.977 53.676-75.621 53.676-32.325 0-76.874-12.08-76.874-44.271V368c0-8.837-7.164-16-16-16H113.75c-8.836 0-16 7.163-16 16v19.204c0 66.845 77.717 101.82 154.487 101.82 88.578 0 162.013-45.438 162.013-134.424 0-19.815-3.618-36.417-10.143-50.6H281.334zm-30.952-96c-32.422-13.505-56.836-28.946-56.836-59.683 0-33.92 30.901-47.406 64.962-47.406 42.647 0 64.962 16.593 64.962 32.985V136c0 8.837 7.164 16 16 16h45.613c8.836 0 16-7.163 16-16v-30.318c0-52.438-71.725-79.875-142.575-79.875-85.203 0-150.726 40.972-150.726 125.646 0 22.71 4.665 41.176 12.777 56.547h129.823z'
  },
  sync: {
    width: 512,
    height: 512,
    path: 'M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z'
  },
  tag: {
    width: 512,
    height: 512,
    path: 'M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z'
  },
  taxi: {
    width: 512,
    height: 512,
    path: 'M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z'
  },
  'text-height': {
    width: 576,
    height: 512,
    path: 'M16 32h288c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-35.496c-8.837 0-16-7.163-16-16V96h-54.761v320H232c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H88c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h34.257V96H67.496v48c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16zm475.308 4.685l79.995 80.001C581.309 126.693 574.297 144 559.99 144H512v224h48c15.639 0 20.635 17.991 11.313 27.314l-79.995 80.001c-6.247 6.247-16.381 6.245-22.626 0l-79.995-80.001C378.691 385.307 385.703 368 400.01 368H448V144h-48c-15.639 0-20.635-17.991-11.313-27.314l79.995-80.001c6.247-6.248 16.381-6.245 22.626 0z'
  },
  'thumbs-down': {
    width: 512,
    height: 512,
    path: 'M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z'
  },
  'thumbs-up': {
    width: 512,
    height: 512,
    path: 'M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z'
  },
  times: {
    width: 352,
    height: 512,
    path: 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z'
  },
  train: {
    width: 448,
    height: 512,
    path: 'M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z'
  },
  trash: {
    width: 448,
    height: 512,
    path: 'M 268 416 h 24 a 12 12 0 0 0 12 -12 V 188 a 12 12 0 0 0 -12 -12 h -24 a 12 12 0 0 0 -12 12 v 216 a 12 12 0 0 0 12 12 Z M 432 80 h -82.41 l -34 -56.7 A 48 48 0 0 0 274.41 0 H 173.59 a 48 48 0 0 0 -41.16 23.3 L 98.41 80 H 16 A 16 16 0 0 0 0 96 v 16 a 16 16 0 0 0 16 16 h 16 v 336 a 48 48 0 0 0 48 48 h 288 a 48 48 0 0 0 48 -48 V 128 h 16 a 16 16 0 0 0 16 -16 V 96 a 16 16 0 0 0 -16 -16 Z M 171.84 50.91 A 6 6 0 0 1 177 48 h 94 a 6 6 0 0 1 5.15 2.91 L 293.61 80 H 154.39 Z M 368 464 H 80 V 128 h 288 Z m -212 -48 h 24 a 12 12 0 0 0 12 -12 V 188 a 12 12 0 0 0 -12 -12 h -24 a 12 12 0 0 0 -12 12 v 216 a 12 12 0 0 0 12 12 Z'
  },
  truck: {
    width: 640,
    height: 512,
    path: 'M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z'
  },
  tty: {
    width: 512,
    height: 512,
    path: 'M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z'
  },
  underline: {
    width: 448,
    height: 512,
    path: 'M224.264 388.24c-91.669 0-156.603-51.165-156.603-151.392V64H39.37c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h137.39c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.813v172.848c0 53.699 28.314 79.444 76.317 79.444 46.966 0 75.796-25.434 75.796-79.965V64h-28.291c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h136.868c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.291v172.848c0 99.405-64.881 151.392-156.082 151.392zM16 448h416c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16z'
  },
  undo: {
    width: 512,
    height: 512,
    path: 'M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z'
  },
  'universal-access': {
    width: 512,
    height: 512,
    path: 'M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z'
  },
  unlink: {
    width: 512,
    height: 512,
    path: 'M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z'
  },
  user: {
    width: 448,
    height: 512,
    path: 'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z'
  },
  'volume-control-phone': {
    width: 384,
    height: 512,
    path: 'M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z'
  },
  wheelchair: {
    width: 512,
    height: 512,
    path: 'M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z'
  },
  wordpress: {
    width: 512,
    height: 512,
    path: 'M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z'
  },
  wpform: {
    width: 448,
    height: 512,
    path: 'M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z'
  }
};

var propTypes$6 = {
  className: PropTypes.string,
  id: PropTypes.oneOf(Object.keys(icons)).isRequired,
  label: PropTypes.string
};
var defaultProps$6 = {
  className: undefined,
  label: undefined
};

var Svg = function Svg(_ref) {
  var className = _ref.className,
      id = _ref.id,
      label = _ref.label;
  var _icons$id = icons[id],
      width = _icons$id.width,
      height = _icons$id.height,
      path = _icons$id.path;
  var titleId = label && label.replace(/\s+/g, '-').toLowerCase();
  return React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, label && React.createElement("title", {
    id: titleId
  }, label), React.createElement("path", {
    fill: "currentColor",
    d: path
  }));
};

Svg.propTypes = propTypes$6;
Svg.defaultProps = defaultProps$6;

var styles$5 = {"Control":"rnl-Editor-Controls-Control","Control__active":"rnl-Editor-Controls-Control--active","Control_dropdown":"rnl-Editor-Controls-Control-dropdown","Control_icon":"rnl-Editor-Controls-Control-icon","Control_caret":"rnl-Editor-Controls-Control-caret"};

var propTypes$7 = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOf(Object.keys(icons)),
  label: PropTypes.string,
  noCaret: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  style: PropTypes.shape({
    color: PropTypes.string,
    borderColor: PropTypes.string
  }),
  text: PropTypes.node
};
var defaultProps$7 = {
  active: undefined,
  children: undefined,
  className: undefined,
  disabled: undefined,
  icon: undefined,
  label: undefined,
  noCaret: undefined,
  onClick: undefined,
  onClose: undefined,
  style: undefined,
  text: undefined
};

var Control = function Control(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className,
      text = _ref.text,
      icon = _ref.icon,
      label = _ref.label,
      noCaret = _ref.noCaret,
      onClick = _ref.onClick,
      onClose = _ref.onClose,
      style = _ref.style;
  var classes = cx(styles$5.Control, active && styles$5.Control__active, !icon && className);
  var svg = icon ? React.createElement("div", {
    className: className,
    style: style
  }, React.createElement(Svg, {
    id: icon,
    label: label,
    className: styles$5.Control_icon
  })) : null;

  if (!children) {
    return React.createElement("button", {
      type: "button",
      onClick: onClick,
      className: classes,
      disabled: disabled
    }, svg, text);
  }

  var caret = React.createElement(Svg, {
    id: "caret-down",
    className: styles$5.Control_caret
  });
  var toggle = React.createElement(Dropdown.Toggle, {
    caret: caret,
    noCaret: noCaret,
    className: classes
  }, svg, text);
  return React.createElement(Dropdown, {
    pull: "left",
    toggle: toggle,
    onClose: onClose,
    className: styles$5.Control_dropdown
  }, children);
};

Control.propTypes = propTypes$7;
Control.defaultProps = defaultProps$7;

var styles$6 = {"BackgroundColor":"rnl-Editor-Controls-BackgroundColor","BackgroundColor_picker":"rnl-Editor-Controls-BackgroundColor-picker","BackgroundColor_buttons":"rnl-Editor-Controls-BackgroundColor-buttons"};

var propTypes$8 = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
var defaultProps$8 = {
  value: undefined
}; // TODO: This should pick up on the computed `background-color` and display that
// as the default value.
// https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle

var BackgroundColor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BackgroundColor, _React$Component);

  function BackgroundColor(props) {
    var _this;

    _classCallCheck(this, BackgroundColor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BackgroundColor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChangeComplete", function (color) {
      return _this.setState({
        color: color.hex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      return _this.setState({
        color: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      var color = _this.state.color;
      var onChange = _this.props.onChange;

      if (color) {
        onChange(color);
      }
    });

    _this.state = {
      color: undefined
    };
    return _this;
  }

  _createClass(BackgroundColor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.props.value;
      var color = this.state.color;
      var backgroundColor = value || CONTROL_COLOR;
      var style = {
        backgroundColor: backgroundColor,
        color: contrastYIQ(backgroundColor)
      };
      return React.createElement(Control, {
        noCaret: true,
        icon: "font",
        style: style,
        onClose: this.onClose,
        label: "Background Color",
        className: styles$6.BackgroundColor
      }, React.createElement(Consumer, null, function (_ref) {
        var colors = _ref.colors;
        return React.createElement(SketchPicker, {
          color: color,
          presetColors: Object.values(colors),
          onChangeComplete: _this2.onChangeComplete,
          className: styles$6.BackgroundColor_picker
        });
      }), React.createElement("div", {
        className: styles$6.BackgroundColor_buttons
      }, React.createElement(Button, {
        size: "sm",
        context: "neutral",
        onClick: this.onDismiss
      }, "Cancel"), React.createElement(Button, {
        size: "sm",
        context: "positive",
        onClick: this.onSubmit
      }, "Apply")));
    }
  }]);

  return BackgroundColor;
}(React.Component);

BackgroundColor.propTypes = propTypes$8;
BackgroundColor.defaultProps = defaultProps$8;
var BackgroundColor$1 = variableInlineColorControl(BackgroundColor, BACKGROUND_COLOR);

var _blockTypes;
var blockTypes = (_blockTypes = {}, _defineProperty(_blockTypes, UNSTYLED, {
  Component: 'p',
  text: 'Normal Text'
}), _defineProperty(_blockTypes, HEADER_ONE, {
  Component: 'h1',
  text: 'Heading 1'
}), _defineProperty(_blockTypes, HEADER_TWO, {
  Component: 'h2',
  text: 'Heading 2'
}), _defineProperty(_blockTypes, HEADER_THREE, {
  Component: 'h3',
  text: 'Heading 3'
}), _defineProperty(_blockTypes, HEADER_FOUR, {
  Component: 'h4',
  text: 'Heading 4'
}), _defineProperty(_blockTypes, HEADER_FIVE, {
  Component: 'h5',
  text: 'Heading 5'
}), _defineProperty(_blockTypes, HEADER_SIX, {
  Component: 'h6',
  text: 'Heading 6'
}), _defineProperty(_blockTypes, BLOCKQUOTE, {
  Component: 'blockquote',
  text: 'Block Quote'
}), _blockTypes);
var propTypes$9 = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};
var defaultProps$9 = {};

var BlockType = function BlockType(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;
  return React.createElement(Control, {
    text: (blockTypes[value] || blockTypes[UNSTYLED]).text
  }, Object.keys(blockTypes).map(function (key) {
    var _blockTypes$key = blockTypes[key],
        Component = _blockTypes$key.Component,
        text = _blockTypes$key.text;
    return React.createElement(Menu.Item, {
      key: key,
      onClick: function onClick() {
        return onChange(key);
      }
    }, React.createElement(Component, null, text));
  }));
};

BlockType.propTypes = propTypes$9;
BlockType.defaultProps = defaultProps$9;
var BlockType$1 = blockTypeControl(BlockType);

var propTypes$a = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$a = {};

var Bold = function Bold(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    icon: "bold",
    label: "Bold",
    active: active,
    onClick: onChange
  });
};

Bold.propTypes = propTypes$a;
Bold.defaultProps = defaultProps$a;
var Bold$1 = toggleableInlineStyleControl(Bold, BOLD);

var styles$7 = {"Color":"rnl-Editor-Controls-Color","Color_picker":"rnl-Editor-Controls-Color-picker","Color_buttons":"rnl-Editor-Controls-Color-buttons"};

var propTypes$b = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
var defaultProps$b = {
  value: undefined
}; // TODO: This should pick up on the computed `color` and display that as the
// default value.
// https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle

var Color =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Color, _React$Component);

  function Color(props) {
    var _this;

    _classCallCheck(this, Color);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Color).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChangeComplete", function (color) {
      return _this.setState({
        color: color.hex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      return _this.setState({
        color: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      var color = _this.state.color;
      var onChange = _this.props.onChange;

      if (color) {
        onChange(color);
      }
    });

    _this.state = {
      color: undefined
    };
    return _this;
  }

  _createClass(Color, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.props.value;
      var color = this.state.color;
      return React.createElement(Consumer, null, function (_ref) {
        var colors = _ref.colors;
        var borderColor = value || CONTENT_BODY_COLOR;
        return React.createElement(Control, {
          noCaret: true,
          icon: "font",
          label: "Color",
          onClose: _this2.onClose,
          style: {
            borderColor: borderColor
          },
          className: styles$7.Color
        }, React.createElement(SketchPicker, {
          color: color,
          className: styles$7.Color_picker,
          presetColors: Object.values(colors),
          onChangeComplete: _this2.onChangeComplete
        }), React.createElement("div", {
          className: styles$7.Color_buttons
        }, React.createElement(Button, {
          size: "sm",
          context: "neutral",
          onClick: _this2.onDismiss
        }, "Cancel"), React.createElement(Button, {
          size: "sm",
          context: "positive",
          onClick: _this2.onSubmit
        }, "Apply")));
      });
    }
  }]);

  return Color;
}(React.Component);

Color.propTypes = propTypes$b;
Color.defaultProps = defaultProps$b;
var Color$1 = variableInlineColorControl(Color, COLOR);

var propTypes$c = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$c = {};

var FieldReplacement$1 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FieldReplacement, _React$Component);

  function FieldReplacement() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FieldReplacement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FieldReplacement)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (key, value) {
      return function () {
        var _this$props = _this.props,
            editorState = _this$props.editorState,
            onChange = _this$props.onChange;
        var newEditorState = createFieldReplacement(editorState, {
          key: key,
          value: value
        });
        onChange(newEditorState);
      };
    });

    return _this;
  }

  _createClass(FieldReplacement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Consumer, null, function (_ref) {
        var fieldReplacements = _ref.fieldReplacements;
        return React.createElement(Control, {
          noCaret: true,
          text: "[...]",
          label: "Replacement"
        }, Object.keys(fieldReplacements).map(function (key) {
          return React.createElement(Menu.Item, {
            key: key,
            onClick: _this2.onChange(key, fieldReplacements[key].value)
          }, fieldReplacements[key].label);
        }));
      });
    }
  }]);

  return FieldReplacement;
}(React.Component);

FieldReplacement$1.propTypes = propTypes$c;
FieldReplacement$1.defaultProps = defaultProps$c;

var propTypes$d = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$d = {};

var File$1 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(File, _React$Component);

  function File(props) {
    var _this;

    _classCallCheck(this, File);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(File).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      return _this.setState({
        show: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDismiss", function () {
      return _this.setState({
        show: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAttach", function (_ref) {
      var text = _ref.text,
          href = _ref.href;
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;
      var selectedText = getSelectedText(editorState);
      var newEditorState = createFileLink(editorState, {
        href: href,
        text: selectedText && !text ? selectedText : text
      });
      onChange(newEditorState);

      _this.onDismiss();
    });

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(File, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var show = this.state.show;
      var editorState = this.props.editorState;
      var editingFileEntity = !!getSelectedEntityWithType(editorState, FILE); // Files can't be inserted across multiple blocks.

      var selection = editorState.getSelection();
      var selectionIsMultiBlock = selection.getStartKey() !== selection.getEndKey();
      return React.createElement(Consumer, null, function (_ref2) {
        var Modal = _ref2.filesModalComponentClass;
        return React.createElement(React.Fragment, null, React.createElement(Control, {
          label: "File",
          icon: "paperclip",
          onClick: _this2.onClick,
          active: editingFileEntity,
          disabled: selectionIsMultiBlock
        }), React.createElement(Modal, {
          show: show,
          onAttach: _this2.onAttach,
          onDismiss: _this2.onDismiss
        }));
      });
    }
  }]);

  return File;
}(React.Component);

File$1.propTypes = propTypes$d;
File$1.defaultProps = defaultProps$d;

var propTypes$e = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
var defaultProps$e = {
  value: undefined
}; // TODO: This should pick up on the computed `font-family` and display that as the
// default value in the dropdown.
// https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle

var FontFamily = function FontFamily(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return React.createElement(Consumer, null, function (_ref2) {
    var fonts = _ref2.fonts;

    if (!fonts.primary && !fonts.secondary) {
      return null;
    }

    var font = fonts[value];
    var text = font ? font.label : 'Font';
    return React.createElement(Control, {
      text: text
    }, Object.keys(fonts).map(function (key) {
      var _fonts$key = fonts[key],
          label = _fonts$key.label,
          fontFamily = _fonts$key.value;
      return React.createElement(Menu.Item, {
        key: fontFamily,
        onClick: function onClick() {
          return onChange(key);
        }
      }, label);
    }));
  });
};

FontFamily.propTypes = propTypes$e;
FontFamily.defaultProps = defaultProps$e;
var FontFamily$1 = variableInlineStyleControl(FontFamily, FONT_FAMILY);

var OPTIONS = [10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72];
var propTypes$f = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
var defaultProps$f = {
  value: '14'
}; // TODO: This should pick up on the computed `font-size` and display that as the
// default value in the dropdown.
// https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle

var FontSize = function FontSize(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    text: value
  }, OPTIONS.map(function (fontSize) {
    return React.createElement(Menu.Item, {
      key: fontSize,
      onClick: function onClick() {
        return onChange(fontSize);
      }
    }, fontSize);
  }));
};

FontSize.propTypes = propTypes$f;
FontSize.defaultProps = defaultProps$f;
var FontSize$1 = variableInlineStyleControl(FontSize, FONT_SIZE);

var propTypes$g = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$g = {};

var Italic = function Italic(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    icon: "italic",
    label: "Italic",
    active: active,
    onClick: onChange
  });
};

Italic.propTypes = propTypes$g;
Italic.defaultProps = defaultProps$g;
var Italic$1 = toggleableInlineStyleControl(Italic, ITALIC);

var styles$8 = {"FormModal_control":"rnl-Editor-Controls-Link-FormModal-control","FormModal_label":"rnl-Editor-Controls-Link-FormModal-label","FormModal_radios":"rnl-Editor-Controls-Link-FormModal-radios","FormModal_radio":"rnl-Editor-Controls-Link-FormModal-radio"};

var propTypes$h = {
  editing: PropTypes.bool.isRequired,
  href: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  target: PropTypes.string,
  text: PropTypes.string
};
var defaultProps$h = {
  href: '',
  target: '_self',
  text: ''
};

var FormModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormModal, _React$Component);

  function FormModal(props) {
    var _this;

    _classCallCheck(this, FormModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      var onSubmit = _this.props.onSubmit;
      onSubmit();
      e.preventDefault();
      return false;
    });

    uniqueId.enableUniqueIds(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FormModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          editing = _this$props.editing,
          href = _this$props.href,
          onChange = _this$props.onChange,
          onDismiss = _this$props.onDismiss,
          onRemove = _this$props.onRemove,
          show = _this$props.show,
          target = _this$props.target,
          text = _this$props.text;
      var titleId = this.getUniqueId('title');
      var hrefId = this.getUniqueId('href');
      var textId = this.getUniqueId('text');
      var selfId = this.getUniqueId('self');
      var blankId = this.getUniqueId('blank');
      return React.createElement(Modal, {
        size: "sm",
        show: show,
        onDismiss: onDismiss,
        "aria-labelledby": titleId
      }, React.createElement("form", {
        onSubmit: this.onSubmit
      }, React.createElement(Modal.Header, null, React.createElement(Modal.Title, {
        id: titleId
      }, editing ? 'Edit' : 'Insert', " Link")), React.createElement(Modal.Body, null, React.createElement("div", {
        className: styles$8.FormModal_control
      }, React.createElement("label", {
        htmlFor: hrefId
      }, React.createElement("span", {
        className: styles$8.FormModal_label
      }, "URL"), React.createElement("input", {
        required: true,
        type: "text",
        name: "href",
        id: hrefId,
        value: href,
        onChange: onChange
      }))), React.createElement("div", {
        className: styles$8.FormModal_control
      }, React.createElement("label", {
        htmlFor: textId
      }, React.createElement("span", {
        className: styles$8.FormModal_label
      }, "Link Text"), React.createElement("input", {
        required: true,
        type: "text",
        name: "text",
        id: textId,
        value: text,
        onChange: onChange
      }))), React.createElement("div", {
        className: styles$8.FormModal_radios
      }, React.createElement("div", {
        className: styles$8.FormModal_radio
      }, React.createElement("label", {
        htmlFor: selfId
      }, React.createElement("input", {
        id: selfId,
        type: "radio",
        name: "target",
        value: "_self",
        onChange: onChange,
        checked: target === '_self'
      }), "Open link in same tab")), React.createElement("div", {
        className: styles$8.FormModal_radio
      }, React.createElement("label", {
        htmlFor: blankId
      }, React.createElement("input", {
        id: blankId,
        type: "radio",
        name: "target",
        value: "_blank",
        onChange: onChange,
        checked: target === '_blank'
      }), "Open link in new tab")))), React.createElement(Modal.Footer, null, React.createElement(Button, {
        size: "sm",
        context: "neutral",
        onClick: onDismiss
      }, "Cancel"), editing && React.createElement(Button, {
        inverted: true,
        size: "sm",
        context: "negative",
        onClick: onRemove
      }, "Remove Link"), React.createElement(Button, {
        size: "sm",
        type: "submit",
        context: "positive"
      }, "Apply"))));
    }
  }]);

  return FormModal;
}(React.Component);

FormModal.propTypes = propTypes$h;
FormModal.defaultProps = defaultProps$h;

var propTypes$i = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$i = {};

var Link$1 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link(props) {
    var _this;

    _classCallCheck(this, Link);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Link).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var editorState = _this.props.editorState;
      var href = getSelectedLinkHref(editorState);
      var target = getSelectedLinkTarget(editorState);
      var text = getSelectedText(editorState);

      _this.setState({
        href: href,
        show: true,
        target: target,
        text: text
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDismiss", function () {
      return _this.setState({
        show: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      return _this.setState(_defineProperty({}, e.target.name, e.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      var _this$state = _this.state,
          href = _this$state.href,
          target = _this$state.target,
          text = _this$state.text;
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;
      var newEditorState = createLink(editorState, {
        href: href,
        target: target,
        text: text
      });
      onChange(newEditorState);

      _this.onDismiss();
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      var _this$props2 = _this.props,
          editorState = _this$props2.editorState,
          onChange = _this$props2.onChange;
      var newEditorState = removeLink(editorState);
      onChange(newEditorState);

      _this.onDismiss();
    });

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          href = _this$state2.href,
          target = _this$state2.target,
          text = _this$state2.text;
      var editorState = this.props.editorState;
      var show = this.state.show;
      var editingLinkEntity = !!getSelectedEntityWithType(editorState, LINK); // Links can't be inserted across multiple blocks.

      var selection = editorState.getSelection();
      var selectionIsMultiBlock = selection.getStartKey() !== selection.getEndKey();
      return React.createElement(React.Fragment, null, React.createElement(Control, {
        icon: "link",
        label: "Link",
        onClick: this.onClick,
        active: editingLinkEntity,
        disabled: selectionIsMultiBlock
      }), React.createElement(FormModal, {
        href: href,
        text: text,
        show: show,
        target: target,
        onRemove: this.onRemove,
        onChange: this.onChange,
        onSubmit: this.onSubmit,
        onDismiss: this.onDismiss,
        editing: editingLinkEntity
      }));
    }
  }]);

  return Link;
}(React.Component);

Link$1.propTypes = propTypes$i;
Link$1.defaultProps = defaultProps$i;

var propTypes$j = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$j = {};

var OrderedList = function OrderedList(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    icon: "list-ol",
    active: active,
    onClick: onChange,
    label: "Numbered List"
  });
};

OrderedList.propTypes = propTypes$j;
OrderedList.defaultProps = defaultProps$j;
var OrderedList$1 = blockTypeControl(OrderedList, ORDERED_LIST_ITEM);

var propTypes$k = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$k = {};

var UndoRedoControls =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UndoRedoControls, _React$Component);

  function UndoRedoControls() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UndoRedoControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UndoRedoControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onRedo", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          editorState = _this$props.editorState;
      var newEditorState = EditorState$1.redo(editorState);
      onChange(newEditorState);
    });

    return _this;
  }

  _createClass(UndoRedoControls, [{
    key: "render",
    value: function render() {
      var editorState = this.props.editorState;
      var redoStackIsEmpty = editorState.getRedoStack().isEmpty();
      return React.createElement(Control, {
        icon: "redo",
        label: "Redo",
        onClick: this.onRedo,
        disabled: redoStackIsEmpty
      });
    }
  }]);

  return UndoRedoControls;
}(React.Component);

UndoRedoControls.propTypes = propTypes$k;
UndoRedoControls.defaultProps = defaultProps$k;

var propTypes$l = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$l = {};

var Strikethrough = function Strikethrough(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    active: active,
    onClick: onChange,
    icon: "strikethrough",
    label: "Strikethrough"
  });
};

Strikethrough.propTypes = propTypes$l;
Strikethrough.defaultProps = defaultProps$l;
var Strikethrough$1 = toggleableInlineStyleControl(Strikethrough, STRIKETHROUGH);

var _OPTIONS;
var OPTIONS$1 = (_OPTIONS = {}, _defineProperty(_OPTIONS, ALIGN_LEFT, {
  id: 'align-left',
  label: 'Align Left'
}), _defineProperty(_OPTIONS, ALIGN_CENTER, {
  id: 'align-center',
  label: 'Align Center'
}), _defineProperty(_OPTIONS, ALIGN_RIGHT, {
  id: 'align-right',
  label: 'Align Right'
}), _defineProperty(_OPTIONS, ALIGN_JUSTIFY, {
  id: 'align-justify',
  label: 'Align Justify'
}), _OPTIONS);
var propTypes$m = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
var defaultProps$m = {
  value: ALIGN_LEFT
};

var TextAlign = function TextAlign(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    noCaret: true,
    label: "Align",
    icon: OPTIONS$1[value].id
  }, Object.keys(OPTIONS$1).map(function (key) {
    return React.createElement(Menu.Item, {
      key: key,
      onClick: onChange(key)
    }, React.createElement(Icon, OPTIONS$1[key]));
  }));
};

TextAlign.propTypes = propTypes$m;
TextAlign.defaultProps = defaultProps$m;
var TextAlign$1 = blockDataControl(TextAlign, ALIGN);

var propTypes$n = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$n = {};

var Underline = function Underline(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    active: active,
    icon: "underline",
    onClick: onChange,
    label: "Underline"
  });
};

Underline.propTypes = propTypes$n;
Underline.defaultProps = defaultProps$n;
var Underline$1 = toggleableInlineStyleControl(Underline, UNDERLINE);

var propTypes$o = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$o = {};

var Undo =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Undo, _React$Component);

  function Undo() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Undo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Undo)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onUndo", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          editorState = _this$props.editorState;
      var newEditorState = EditorState$1.undo(editorState);
      onChange(newEditorState);
    });

    return _this;
  }

  _createClass(Undo, [{
    key: "render",
    value: function render() {
      var editorState = this.props.editorState;
      var undoStackIsEmpty = editorState.getUndoStack().isEmpty();
      return React.createElement(Control, {
        icon: "undo",
        label: "Undo",
        onClick: this.onUndo,
        disabled: undoStackIsEmpty
      });
    }
  }]);

  return Undo;
}(React.Component);

Undo.propTypes = propTypes$o;
Undo.defaultProps = defaultProps$o;

var propTypes$p = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
var defaultProps$p = {};

var UnorderedList = function UnorderedList(_ref) {
  var active = _ref.active,
      onChange = _ref.onChange;
  return React.createElement(Control, {
    icon: "list-ul",
    active: active,
    onClick: onChange,
    label: "Bullet List"
  });
};

UnorderedList.propTypes = propTypes$p;
UnorderedList.defaultProps = defaultProps$p;
var UnorderedList$1 = blockTypeControl(UnorderedList, UNORDERED_LIST_ITEM);

var styles$9 = {"Controls":"rnl-Editor-Controls"};

var propTypes$q = {};
var defaultProps$q = {};

var Controls = function Controls(_ref) {
  var props = _extends({}, _ref);

  return React.createElement("div", {
    className: styles$9.Controls
  }, React.createElement(Undo, props), React.createElement(UndoRedoControls, props), React.createElement(BlockType$1, props), React.createElement(FontFamily$1, props), React.createElement(FontSize$1, props), React.createElement(Bold$1, props), React.createElement(Italic$1, props), React.createElement(Underline$1, props), React.createElement(Strikethrough$1, props), React.createElement(Color$1, props), React.createElement(BackgroundColor$1, props), React.createElement(TextAlign$1, props), React.createElement(UnorderedList$1, props), React.createElement(OrderedList$1, props), React.createElement(Link$1, props), React.createElement(File$1, props), React.createElement(FieldReplacement$1, props));
};

Controls.propTypes = propTypes$q;
Controls.defaultProps = defaultProps$q;

var styles$a = {"Debug":"rnl-Editor-Debug","Debug_section":"rnl-Editor-Debug-section","Debug_header":"rnl-Editor-Debug-header"};

var propTypes$r = {
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired
};
var defaultProps$r = {};

var Debug = function Debug(_ref) {
  var editorState = _ref.editorState;
  var contentState = editorState.getCurrentContent();
  var rawContentState = convertToRaw(contentState);
  return React.createElement("div", {
    className: styles$a.Debug
  }, React.createElement("div", {
    className: styles$a.Debug_section
  }, React.createElement("div", {
    className: styles$a.Debug_header
  }, "Raw Content State"), React.createElement("pre", null, JSON.stringify(rawContentState, null, 2))), React.createElement("div", {
    className: styles$a.Debug_section
  }, React.createElement("div", {
    className: styles$a.Debug_header
  }, "Selection State"), React.createElement("pre", null, JSON.stringify(editorState.getSelection(), null, 2))));
};

Debug.propTypes = propTypes$r;
Debug.defaultProps = defaultProps$r;

var styles$b = {"Footer":"rnl-Editor-Footer"};

var propTypes$s = {
  onDismiss: PropTypes.func,
  onSave: PropTypes.func
};
var defaultProps$s = {
  onDismiss: undefined,
  onSave: undefined
};

var Footer = function Footer(_ref) {
  var onDismiss = _ref.onDismiss,
      onSave = _ref.onSave;

  if (!(onDismiss || onSave)) {
    return null;
  }

  return React.createElement("div", {
    className: styles$b.Footer
  }, onDismiss && React.createElement(Button, {
    size: "sm",
    context: "neutral",
    onClick: onDismiss
  }, "Cancel"), onSave && React.createElement(Button, {
    size: "sm",
    onClick: onSave,
    context: "positive"
  }, "Save"));
};

Footer.propTypes = propTypes$s;
Footer.defaultProps = defaultProps$s;

var styles$c = {"Editor":"rnl-Editor","Editor_content":"rnl-Editor-content"};

var propTypes$t = {
  colors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string,
    tertiary: PropTypes.string
  }),
  debug: PropTypes.bool,
  editorKey: PropTypes.string,
  fieldReplacements: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  filesModalComponentClass: PropTypes.func.isRequired,
  fonts: PropTypes.shape({
    primary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    secondary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  }),
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  onSave: PropTypes.func,
  rawContentState: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.object).isRequired,
    entityMap: PropTypes.object.isRequired
  })
};
var defaultProps$t = {
  colors: {},
  debug: undefined,
  editorKey: undefined,
  fieldReplacements: {},
  fonts: {},
  onChange: undefined,
  onDismiss: undefined,
  onSave: undefined,
  rawContentState: undefined
};

var Editor =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Editor, _React$PureComponent);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Editor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (editorState) {
      var onChange = _this.props.onChange;

      _this.setState({
        editorState: editorState
      });

      if (typeof onChange === 'function') {
        var contentState = editorState.getCurrentContent();
        var rawContentState = convertToRaw(contentState);
        onChange(rawContentState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var editorState = _this.state.editorState;
      var onSave = _this.props.onSave;

      if (typeof onSave !== 'function') {
        return;
      }

      var contentState = editorState.getCurrentContent();
      var rawContentState = convertToRaw(contentState);
      onSave(rawContentState);
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      _this.draft.current.focus();
    });

    var _rawContentState = props.rawContentState,
        fieldReplacements = props.fieldReplacements;

    var _editorState = convertToEditorState(_rawContentState, null, {
      fieldReplacements: fieldReplacements
    });

    _this.state = {
      editorState: _editorState
    };
    _this.draft = React.createRef();
    return _this;
  }

  _createClass(Editor, [{
    key: "render",
    value: function render() {
      var editorState = this.state.editorState;
      var _this$props = this.props,
          colors = _this$props.colors,
          debug = _this$props.debug,
          editorKey = _this$props.editorKey,
          fieldReplacements = _this$props.fieldReplacements,
          filesModalComponentClass = _this$props.filesModalComponentClass,
          fonts = _this$props.fonts,
          onDismiss = _this$props.onDismiss,
          onSave = _this$props.onSave;
      var theme = createTheme({
        colors: colors,
        fieldReplacements: fieldReplacements,
        filesModalComponentClass: filesModalComponentClass,
        fonts: fonts
      });
      return React.createElement("div", {
        className: styles$c.Editor
      }, React.createElement(Provider, {
        value: theme
      }, React.createElement(Controls, {
        onChange: this.onChange,
        editorState: editorState
      }), React.createElement("div", {
        role: "textbox",
        onFocus: this.onFocus,
        tabIndex: "-1",
        className: styles$c.Editor_content
      }, React.createElement(Editor$1, {
        ref: this.draft,
        editorKey: editorKey,
        onChange: this.onChange,
        spellcheck: true,
        editorState: editorState,
        customStyleMap: InlineStyleMap,
        blockRenderMap: BlockRenderMap,
        blockStyleFn: applyBlockClasses,
        customStyleFn: applyInlineStyles(theme)
      })), debug && React.createElement(Debug, {
        editorState: editorState
      }), React.createElement(Footer, {
        onSave: onSave ? this.onSave : undefined,
        onDismiss: onDismiss
      })));
    }
  }]);

  return Editor;
}(React.PureComponent);

Editor.propTypes = propTypes$t;
Editor.defaultProps = defaultProps$t;

var propTypes$u = {
  colors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string,
    tertiary: PropTypes.string
  }),
  debug: PropTypes.bool,
  editing: PropTypes.bool,
  editorKey: PropTypes.string,
  fieldReplacements: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  filesModalComponentClass: PropTypes.func.isRequired,
  fonts: PropTypes.shape({
    primary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    secondary: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  }),
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  onSave: PropTypes.func,
  rawContentState: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.object).isRequired,
    entityMap: PropTypes.object
  })
};
var defaultProps$u = {
  colors: {},
  debug: undefined,
  editing: undefined,
  editorKey: undefined,
  fieldReplacements: {},
  fonts: {},
  onChange: undefined,
  onDismiss: undefined,
  onSave: undefined,
  rawContentState: undefined
};

var EditableContent = function EditableContent(_ref) {
  var colors = _ref.colors,
      debug = _ref.debug,
      editing = _ref.editing,
      editorKey = _ref.editorKey,
      fieldReplacements = _ref.fieldReplacements,
      filesModalComponentClass = _ref.filesModalComponentClass,
      fonts = _ref.fonts,
      onChange = _ref.onChange,
      onDismiss = _ref.onDismiss,
      onSave = _ref.onSave,
      rawContentState = _ref.rawContentState;
  return editing ? React.createElement(Editor, {
    fonts: fonts,
    debug: debug,
    colors: colors,
    onSave: onSave,
    onChange: onChange,
    editorKey: editorKey,
    onDismiss: onDismiss,
    rawContentState: rawContentState,
    fieldReplacements: fieldReplacements,
    filesModalComponentClass: filesModalComponentClass
  }) : React.createElement(Content, {
    fonts: fonts,
    colors: colors,
    rawContentState: rawContentState,
    fieldReplacements: fieldReplacements
  });
};

EditableContent.propTypes = propTypes$u;
EditableContent.defaultProps = defaultProps$u;

/**
 * Returns the full plaintext value of the raw ContentState, joined with a delimiter.
 * If no delimiter is specified, the line feed character (\u000A) is used.
 * @param  {object} rawContentState
 * @param  {string} delimiter
 * @return {string}
 */

var convertToPlainText = (function (rawContentState, delimiter) {
  if (!rawContentState) {
    return EditorState.createEmpty();
  }

  var contentState = convertFromRaw(rawContentState);
  var plainText = contentState.getPlainText(delimiter);
  return plainText;
});

/**
 * Returns the full raw ContentState of the given HTML.
 * @param  {string} html
 * @return {object}
 */

var convertFromHtmlToRaw = (function (html) {
  if (!html) {
    var _contentState = ContentState.createFromText('');

    var _rawContentState = convertToRaw(_contentState);

    return _rawContentState;
  }

  var blocksFromHTML = convertFromHTML(html);
  var contentState = blocksFromHTML && blocksFromHTML.contentBlocks ? ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap) : ContentState.createFromText('');
  var rawContentState = convertToRaw(contentState);
  return rawContentState;
});

export { Content, EditableContent, Editor, convertFromHtmlToRaw, convertToPlainText };
